// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-mKgrZ","columnOrientation":"columnOrientation-Ndu_r","rowOrientation":"rowOrientation-bHt0n"};